import { UpdateCustomFields, UpdateFuelSurchargeFields } from "../dtos/UpdateRateCardRequest";
import { UpdateRouteRateUIRequest } from "../routeRate/UpdateRouteRateModal";

export const mapValuesUiRequestToUpdateCustomFields = (
  uiRequest: UpdateRouteRateUIRequest
  //username: string | undefined
): UpdateCustomFields[] => {
  let customfieldList: UpdateCustomFields[] = []; 
  if (uiRequest.show_custom_fields) {
    if (uiRequest.rateCardCustomFieldsData.length > 0) {
      uiRequest.rateCardCustomFieldsData.forEach((customfield) => {
        if (customfield.ratecardCustomFieldName ) {
          let field: UpdateCustomFields = {
            id: customfield.id ?? undefined,
           
            ratecardCustomFieldName:customfield.ratecardCustomFieldName,
            ratecardCustomFieldAmount:Number(parseFloat(String(customfield.ratecardCustomFieldAmount)).toFixed(2)),

            ratecardCustemFieldPerPackage: customfield.ratecardCustemFieldPerPackage,
            ratecardCustomFieldApplicableFor: customfield.ratecardCustomFieldApplicableFor,

          
          };
          customfieldList.push(field);
        }
      });
    }
  }
  return customfieldList;
};